import { NavLink } from 'react-router-dom';
import logo from '../../../assets/logo-white.svg';

const NAV_ITEMS = [
  { path: '/admin',         label: 'Prehľad'       },
  { path: '/admin/tenants', label: 'Subjekty'       },
  { path: '/admin/users',   label: 'Používatelia'  },
  { path: '/admin/logs',    label: 'Logy'           },
  { path: '/admin/cron',    label: 'Cron'           },
];

export default function Sidebar() {
  return (
    <aside className="adm-sidebar">
      <div className="adm-brand">
        <img src={logo} className="adm-brand-logo" alt="Envicloud" />
        <span className="adm-brand-badge">admin</span>
      </div>

      <nav className="adm-nav" aria-label="Admin navigation">
        {NAV_ITEMS.map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/admin'}
            className={({ isActive }) =>
              `adm-nav-item${isActive ? ' adm-nav-item--active' : ''}`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="adm-sidebar-footer">
        <span className="adm-version">v1.0.0</span>
      </div>
    </aside>
  );
}
